import { useMutation, useQueryClient } from '@tanstack/react-query';
import useAppToast from '@/hooks/useAppToast';
import {
  updateInformation,
  InformationCreatePayload,
  AdminInformationResponse,
} from '@/services/admin/informations';
import { getApiErrorMessage } from '@/utils/apiError';

export const useAdminInformationUpdate = () => {
  const queryClient = useQueryClient();
  const toast = useAppToast();

  const { mutateAsync: updateInformationMutation, isPending: isLoading } = useMutation<
    AdminInformationResponse,
    Error,
    { siteType: string; id: number; data: InformationCreatePayload }
  >({
    mutationFn: ({ siteType, id, data }) => updateInformation(siteType, id, data),
    meta: { suppressNotFoundToast: true },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['informations', variables.siteType],
      });
      toast.success('更新しました。');
    },
    onError: error => {
      const msg = getApiErrorMessage(
        error,
        'エラーが発生しました。しばらくしてから再度お試しください。'
      );
      toast.error(msg);
    },
  });

  return { updateInformationMutation, isLoading };
};
